export default () => {
  document.querySelectorAll('.typography table tbody td').forEach(el => {
    switch (el.textContent) {
      case '–':
        el.innerHTML = '<span class="large-hyphen">–</span>';
        break;
      case '❌':
        el.innerHTML = '<span class="cross-mark-icon"></span>';
        break;
      case '✔️':
        el.innerHTML = '<span class="check-mark-icon"></span>';
        break;
    }
  });
};
